import React, { useEffect, useRef } from 'react';
import styles from './Connect.module.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import arrow from '../images/Arrow.png';

const Connect = () => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);

  useEffect(() => {
    // Ensure Leaflet CSS is loaded
    const ensureLeafletCss = () => {
      const href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.integrity = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';
        link.crossOrigin = '';
        document.head.appendChild(link);
      }
    };

    // Ensure Leaflet JS is loaded
    const ensureLeafletJs = () => new Promise((resolve) => {
      if (window.L && typeof window.L.map === 'function') {
        resolve();
        return;
      }
      const src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      const existing = document.querySelector(`script[src="${src}"]`);
      if (existing) {
        existing.addEventListener('load', () => resolve());
        return;
      }
      const script = document.createElement('script');
      script.src = src;
      script.integrity = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';
      script.crossOrigin = '';
      script.addEventListener('load', () => resolve());
      document.body.appendChild(script);
    });

    const init = async () => {
      ensureLeafletCss();
      await ensureLeafletJs();
      const humberCoords = [43.596831, -79.51409];
      if (mapRef.current && !mapInstanceRef.current) {
        mapInstanceRef.current = window.L.map(mapRef.current).setView(humberCoords, 16);
        window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(mapInstanceRef.current);
        window.L.marker(humberCoords).addTo(mapInstanceRef.current)
          .bindPopup('<b>Humber College - F Building</b><br>This is the spot!')
          .openPopup();
      }
    };
    init();

    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
    };
  }, []);

  return (
    <div className={styles.pageContainer}>
      <Header />
      <main className={styles.connectContainer}>
        <div style={{
          display: 'flex', flexWrap: 'wrap', gap: '4rem', width: '100%', maxWidth: 1100,
          justifyContent: 'center', alignItems: 'flex-start', margin: '0 auto'
        }}>
          <div style={{ flex: 1, minWidth: 300, paddingTop: '5%', fontFamily: "'Bebas Neue', sans-serif", fontSize: '120%' }}>
            <h2 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '2.1rem', lineHeight: 1.4, margin: 0, fontWeight: 700, letterSpacing: 0.5 }}>
              LOOKING FOR A SOLUTION TO<br />
              YOUR CREATIVE PROBLEM?<br />
              GOT A COOL IDEA?<br />
              JUST LOOKING TO CHAT?
            </h2>
            <p style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '2.1rem', lineHeight: 1.4, margin: 0, fontWeight: 700, letterSpacing: 0.5 }}>
              YOU CAN REACH OUR DIRECTOR,<br />
              <span style={{ color: '#F9DE4B' }}>JESSICA FOWLER</span>, BELOW.<br />
              <a href="mailto:NEXT@HUMBER.CA" style={{ color: '#F9DE4B', textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">NEXT@HUMBER.CA</a>
            </p>
          </div>
          <div style={{ flex: 1, minWidth: 300, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: 0 }}>
              <h3 style={{ color: '#FF007F', fontWeight: 700, fontSize: '1.17rem', margin: 0, letterSpacing: 1, fontFamily: "'Bebas Neue', sans-serif" }}>COME FIND US IN PERSON</h3>
              <img src={arrow} alt="" style={{ width: 105.74, height: 70.5, transform: 'translate(-35%, -15%)' }} />
            </div>
            <div id="map" ref={mapRef} style={{ width: '100%', height: 300, background: '#D9D9D9', border: '2px solid #E0E0E0', marginTop: -10 }} />
            <div style={{ marginTop: '1rem', fontSize: '1rem', lineHeight: 1.5, fontWeight: 400, fontFamily: 'Inter, sans-serif' }}>
              Humber College—F Building<br />
              15 Colonel Samuel Smith Park Dr.<br />
              Etobicoke, ON M8V 4B6
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Connect; 